export default {
    'download.modal.title': 'User Profile Confirmation',
    'download.modal.tip': 'To improve our data services, please fill in the following information',

    'download.modal.profession': 'Profession',
    'download.modal.student': 'Student',
    'download.modal.employee': 'Employee',
    'download.modal.researcher': 'Researcher',
    'download.modal.freelancer': 'Freelancer',
    'download.modal.other': 'Other',

    'download.modal.org': 'Organization',

    'download.modal.email': 'Email',

    'download.modal.research.direction': 'Field',
    'download.modal.large.model': 'Large Model',
    'download.modal.artificial.intelligence': 'Artificial Intelligence',
    'download.modal.machine.learning':'Machine Learning',
    'download.modal.NLP': 'NLP',
    'download.modal.CV': 'CV',
    'download.modal.autonomous.driving': 'Autonomous Driving',
    'download.modal.robotic.learning':'Robotic Learning',
    'download.modal.medical.health': 'Medical Health',
    'download.modal.smart.retail': 'Smart Retail',
    'download.modal.intelligent.finance': 'Intelligent Finance',
    'download.modal.others': 'Others',

    'download.modal.required.org': 'Please enter a valid organization',
    'download.modal.rule.org': 'Input characters are restricted',
    'download.modal.limit.org': 'Enter up to 50 characters',
    'download.modal.required.email': 'Please enter a valid email address',
    'download.modal.rule.email': 'Email format error',
    'download.modal.required.profession': 'Please select an option',
    'download.modal.required.research.direction': 'Please select at least one option'
};